import {JavascriptFunctionName} from "../JavascriptFunctionName";
import {AbstractJavascriptFunctionCallVO} from "./AbstractJavascriptFunctionCallVO";

export class JavascriptCallSetLanguageVO implements AbstractJavascriptFunctionCallVO {

    public functionName = JavascriptFunctionName.SET_LANGUAGE;
    public parameters = [];

    constructor(languageCode: string) {
        this.parameters.push(languageCode);
    }
}
